import { VariableConsumptionMap } from '@app-velocity/common/types';

import { ConvertedImageRaw } from '../../types';

import { ChallengeSaveError } from '../../../types';

import { createCoreMethod } from '../../utils/createCoreMethod';
import { getImageForNode } from '../../utils/getImageForNode';
import { isNodeWithSize } from '../../utils/isNodeWithSize';
import { shallowFindInContainer } from '../../utils/shallowFind';
import { isNodeWithChildren } from '../../utils/isNodeWithChildren';

export const getVariantNodeImage = createCoreMethod(
  'getVariantNodeImage',
  async (
    nodeId: string,
    parentNodeId = undefined
  ): Promise<ConvertedImageRaw | ChallengeSaveError> => {
    await figma.currentPage.loadAsync();
    let parentNode: BaseNode | null = figma.currentPage;

    if (parentNodeId) {
      parentNode = shallowFindInContainer(parentNodeId, figma.currentPage);

      if (!parentNode) {
        parentNode = figma.currentPage.findOne((n) => n.id === parentNodeId);
      }
    }

    if (!parentNode) {
      parentNode = figma.currentPage;
    }

    // @TODO - check if parent is valid there
    if (!parentNode || !isNodeWithChildren(parentNode)) {
      return { type: 'NODE_NOT_FOUND' };
    }

    let node: BaseNode | null = shallowFindInContainer(nodeId, parentNode);

    if (!node) {
      node = parentNode.findOne((n) => n.id === nodeId);
    }

    // last chance to find the node outside of the parent
    if (!node) {
      parentNode = figma.currentPage;
      node = parentNode.findOne((n) => n.id === nodeId);
    }

    if (!node || !isNodeWithSize(node)) {
      return { type: 'NODE_NOT_FOUND' };
    }

    try {
      // if node itself is using variables to control visibility it needs to be displayed to be exported
      if (
        'variableConsumptionMap' in node &&
        (node.variableConsumptionMap as VariableConsumptionMap)['VISIBLE']
      ) {
        const clonedNode = node.clone();
        clonedNode.visible = true;
        if ('opacity' in clonedNode) clonedNode.opacity = 1;
        const result = await getImageForNode(clonedNode, true);
        clonedNode.remove();

        if ('converted' in result) {
          return {
            converted: result.converted.take(),
          };
        }

        return result;
      }

      const result = await getImageForNode(node, true);

      if ('converted' in result) {
        return {
          converted: result.converted.take(),
        };
      }

      return result;
    } catch {
      return { type: 'NODE_NOT_FOUND', nodeId: node.id, nodeName: node.name };
    }
  }
);
